angular.
module("dx.webapp.lists").
component("dxRubricEntry", {
	templateUrl: "tmpl/lists/rubric-entry-component.html",
	controller: "DxRubricEntryController",
	controllerAs: "vm",
	bindings: {
		rubric: "=",
	},
	require: {
		rubriclistCtrl: "^dxRubriclist",
	},
});
